import { render } from "./MerchComponent.vue?vue&type=template&id=0806f2cf&scoped=true"
import script from "./MerchComponent.vue?vue&type=script&lang=js"
export * from "./MerchComponent.vue?vue&type=script&lang=js"

import "./MerchComponent.vue?vue&type=style&index=0&id=0806f2cf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0806f2cf"]])

export default __exports__